import { Button, Container } from "@fluidattacks/design";
import { useTranslation } from "react-i18next";

import { CVSS3Toggle } from "components/cvss3-toggle";
import { usePermissions } from "context/authz/hooks/use-permissions";

const ActionButtons = ({
  areVulnsSelected,
  refreshVulns,
  onApprove,
}: Readonly<{
  areVulnsSelected: boolean;
  refreshVulns: () => void;
  onApprove: () => void;
}>): JSX.Element => {
  const { t } = useTranslation();
  const { someGroupPermissions } = usePermissions();

  return (
    <Container
      alignItems={"center"}
      display={"flex"}
      gap={0.5}
      justify={"flex-end"}
      mr={0.5}
      width={"100%"}
    >
      <CVSS3Toggle />
      <Button
        icon={"refresh"}
        id={"refresh-drafts"}
        onClick={refreshVulns}
        variant={"ghost"}
      >
        {t("todoList.refresh")}
      </Button>
      {someGroupPermissions.canMutate(
        "approve_vulnerabilities_severity_update",
      ) && (
        <Button
          disabled={!areVulnsSelected}
          icon={"check"}
          id={"start-severity-approval"}
          onClick={onApprove}
          tooltip={t("severityUpdateRequests.approveSeverityChanges.tooltip")}
          variant={"ghost"}
        >
          {t("severityUpdateRequests.approveSeverityChanges.text")}
        </Button>
      )}
    </Container>
  );
};

export { ActionButtons };
